import React, {useState} from 'react';
import ThemableSvgIcon from "./theme/ThemableSvgIcon";
import { useLingui } from '@lingui/react/macro';

function SelectDropdown(props) {

    const {showPlaceHolder = true} = props;

    const [isOpen, setIsOpen] = useState(false);
    const {t} = useLingui();

    const handleBlur = (e) => {
        setIsOpen(false);
        if(props.handleBlur) {
            props.handleBlur(e);
        }
    };

    const handleClick = (e) => {
        if(e.currentTarget === e.target) {
            setIsOpen(!isOpen);
        }
    };

    const handleChange = (e) => {
        setIsOpen(false);
        props.handleChange(e);
    };

    let options = props.options;
    if(props.options &&  typeof props.options?.[0] === "object" && showPlaceHolder){
        options = [{label:t({id: "please_select_one_option"}), value: ""}, ...props.options];
    }

    return (
        <div className={props.classes ? props.classes : ""}>
            <label htmlFor={props.selectId} className={props.labelClasses || "block text-primary-dark mb-2"}>
                {props.label}
            </label>

            <div className="relative">
                <select id={props.selectId}
                        disabled={props.disabled}
                        className={`w-full border rounded px-2 py-3 appearance-none ${props.disabled ? "cursor-not-allowed " : "cursor-pointer "}${props.error ? "border border-red" : ""}`}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        onClick={handleClick}
                        value={props.value}>
                    {options.map((option, index) =>
                        typeof option === "object" ?
                        <option key={index} value={option.value} >{option.label}</option> :
                        <option key={index} value={option} >{option}</option>
                    )}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center mr-3">
                    <ThemableSvgIcon name={isOpen ? "chevron-up" : "chevron-down"} className="text-primary w-6 h-6 inline ml-2"/>
                </div>
            </div>
        </div>
    );
}

export default SelectDropdown;